export default "__VITE_ASSET__a4fe3da2__"